import * as XLSX from "xlsx";

const FORMULA_ERROR_REF = "#REF!";
const FORMULA_ERROR_REF_VALUE = 23;
export const NUMBER_FORMAT_2_DECIMALS = "0.00";

// Helper function to find a value in a range of cells, handling merged cells
export const findCellWithValueInRange = (
  worksheet,
  value,
  startRow,
  endRow,
  startCol,
  endCol,
) => {
  for (let row = startRow; row <= endRow; row++) {
    for (let col = startCol; col <= endCol; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
      const cellValue = getMergedCellValue(worksheet, cellAddress);

      if (cellValue === value) {
        return { row, col };
      }
    }
  }
  return null; // Not found
};

// Helper function to get merged cell value
export const getMergedCellValue = (worksheet, cellAddress) => {
  if (!worksheet || !cellAddress) return undefined;

  // Check if the cell is part of a merged range
  const merges = worksheet["!merges"] || [];

  // Find if our cell is in any merged range
  const cellRef = XLSX.utils.decode_cell(cellAddress);
  for (const merge of merges) {
    if (
      cellRef.r >= merge.s.r &&
      cellRef.r <= merge.e.r &&
      cellRef.c >= merge.s.c &&
      cellRef.c <= merge.e.c
    ) {
      // This cell is part of a merged range
      // The value is stored at the top-left cell of the merged range
      const topLeftCellAddress = XLSX.utils.encode_cell(merge.s);
      return worksheet[topLeftCellAddress]?.v;
    }
  }
  const isFormulaRefError = (worksheet[cellAddress]?.w === FORMULA_ERROR_REF &&
    worksheet[cellAddress]?.v === FORMULA_ERROR_REF_VALUE);

  // If not in a merged range, return the cell's own value
  return (isFormulaRefError) ? null : worksheet[cellAddress]?.v;
};

// Helper function to format Excel date values
export const formatExcelDate = (value) => {
  if (typeof value === "number" && value > 1000) {
    return XLSX.SSF.format("dd-mmm-yy", value);
  }
  return value;
};

export const formatDateForExport = (milliseconds) => {
  if (milliseconds) {
    // Create date and set it to midnight UTC
    const date = new Date(milliseconds);
    const utcDate = new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0,
        0,
      ),
    );

    const day = utcDate.getUTCDate().toString().padStart(2, "0");
    const month = new Intl.DateTimeFormat("en-US", {
      month: "short",
      timeZone: "UTC",
    }).format(utcDate);
    const year = utcDate.getUTCFullYear();
    return `${day}-${month}-${year}`;
  }
  return null;
};